/**
 * French (France). Scaffolded, not translated — same convention as
 * @equinox/shared. Missing keys fall back to es-MX.
 */

import type { AdminMessages } from './index.js';

export const adminFrFR: Partial<AdminMessages> = {};
